<template>
  <div>
    <div class="details-banner">
      <div class="details-intro">
        <el-row :gutter="40">
          <el-col :span="24">
            <div class="title">{{ detail.productTitle }}</div>
          </el-col>
          <el-col :xs="24" :md="18">
            <div class="subtitle">{{ detail.productIntroduction }}</div>
          </el-col>
          <el-col :xs="24" :md="6">
            <div class="subtitle">{{ detail.productionCompany }}<br />{{ detail.contactEmail }}</div>
          </el-col>
          <el-col :xs="24" :md="12" style="margin-top: 10px">
            <el-row :gutter="20">
              <el-col :xs="12" :lg="8" :xl="6" style="margin-bottom: 10px">
                <div class="btn" @click="() => { open = true; title = detail.productTitle }">产品咨询</div>
              </el-col>
              <el-col :xs="12" :lg="8" :xl="6">
                <!-- <div class="btn1" @click="toSystem(detail.systemLink)">进入系统</div> -->
                <!-- <div class="btn1">进入系统 <i style="margin-left: 8px;" class="el-icon-arrow-down"></i></div> -->
                <ul class="inbutton" :class="mousein ? 'inmouse' : ''" @mouseover="inMouse" @mouseout="outMouse"
                  v-if="detail.linkStatus == '1' && detail.systemLinkData !== null && detail.systemLinkData.length > 1">
                  <li class="btn1">进入系统 <i style="margin-left: 8px;" class="el-icon-arrow-down"></i></li>
                  <li v-for="(item, index) in detail.systemLinkData" :key="index" @click="toSystem(item.url)">{{ item.name
                  }}</li>
                </ul>
                <div v-else-if="detail.linkStatus == '1' && detail.systemLinkData !== null && detail.systemLinkData"
                  class="btn1" @click="toSystem(detail.systemLinkData[0].url)">进入系统</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <img :src="detail.backgroundImage" style="width: 100%; height: 100%">
    </div>
    <div class="details-container">
      <div class="contant">
        <div class="item" v-for="(item, index) in detail.infoList" :key="index" v-if="item.moduleStatus === '1'">
          <div class=" contant-title" v-if="detail.infoList && item.moduleName !== '自定义模块'">
            <span></span>
            <span>{{ item.moduleTitle }}</span>
          </div>
          <el-row :gutter="20">
            <!-- 痛点模块 -->
            <div v-if="item.moduleName === '痛点模块'">
              <el-col v-for="(v, i) in item.contentList" :key="v.id" :xs="24" :sm="8" :lg="6">
                <div class="box">

                  <div class="label hidden-1">{{ v.subtitle || i + 1 > 9 ? i + 1 : '0' + (i + 1) }}
                  </div>
                  <div class="desc hidden-3">{{ v.introduction }}</div>
                </div>
              </el-col>
            </div>
            <!-- 案例模块 -->
            <div v-if="item.moduleName === '案例模块'">
              <el-col v-for="(v, i) in item.contentList" :key="v.id" :xs="24" :sm="8" :lg="6">
                <div class="box" @click="toPage(v)">

                  <div class="label hidden-1" style="font-size: 20px;font-weight: 600">{{ v.subtitle }}
                  </div>
                  <div class="desc hidden-3">{{ v.introduction }}</div>
                </div>
              </el-col>
            </div>

            <!-- 功能模块 -->
            <div v-if="item.moduleName === '功能模块'">
              <el-col v-for="(v, i) in item.contentList" :key="v.id" :xs="24" :md="11" style="margin-bottom: 20px">
                <div style=" margin-top: 10px;" class="evenflow_scale">
                  <el-row :gutter="20">
                    <el-col :xs="8" :md="8" :lg="6" :xl="5">
                      <img :src="v.picture" style="width: 80px;min-height: 66px">
                    </el-col>
                    <el-col :xs="16" :md="14" :lg="16" :xl="17">
                      <label style="font-size: 18px; color: #131415;">{{ v.subtitle }}</label>
                      <div class="module-detail">{{ v.introduction }}
                      </div>
                    </el-col>

                  </el-row>
                </div>
              </el-col>

            </div>
            <!-- 自定义模块 -->
            <div v-if="item.moduleName === '自定义模块' && item.contentList.length">
              <el-col :span="24" v-for="(v, i) in item.contentList" :key="v.id" v-if="v.type">
                <div class="contant-title" v-if="v.type === 'subtitle' && v.subtitle">
                  <span></span>
                  <span>{{ v.subtitle }}</span>
                </div>
                <div style="font-size: 16px;line-height: 28px;white-space: pre-wrap;padding: 16px 0;"
                  v-if="v.type === 'introduction' && v.introduction">{{ v.introduction }}</div>

                <div v-if="v.type === 'picture' && v.picture" style="width: 100%">
                  <img :src="v.picture" style="width: 100%;margin:25px 0" />
                </div>
                <div v-if="v.type === 'video' && v.video" style="width: 1000px;height: 562px;  margin: 0 auto 50px auto;">
                  <video style="width: 100%" :src="v.video" muted loop controls>
                    <source type="video/mp4" :src="v.video" />
                  </video>
                </div>
              </el-col>
            </div>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 产品咨询对话框 -->
    <consult v-if="open" :dialogVisible="open" @cancel="cancle" :productName="title" :isProduc="true" productId="0">
    </consult>
  </div>
</template>

<script>
import data from './data'
import { detailProduct } from '@/api'
export default {
  name: 'ProductDetails',
  mixins: [data],
  data() {
    return {
      open: false,
      title: undefined,
      mousein: false,
      list: [],
      website: undefined,
      bannerBg: undefined,
      detail: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await detailProduct({ id: this.$route.query.id })
      this.detail = res.data
    },
    cancle(data) {
      this.open = data
    },
    toSystem(url) {
      let jumpUrl = url
      const result = jumpUrl.match('login')
      if (!result) {
        if (url !== 'http://cwzx.eiiplat.com/taxPlan/index') {
          url = `${url}#/login`
          window.open(url + (localStorage.usertoken ? `?token=${localStorage.usertoken}` : ''))
        } else {
          window.open(url + (localStorage.usertoken ? `?token=${localStorage.usertoken}&userId=${localStorage.userId}` : ''))
        }
      }

    },
    toPage(item) {
      this.$router.push({ path: '/solition_lower', query: { id: item.linkInfo } })
    },
    inMouse() {  // 鼠标移入
      this.mousein = true;
    },
    outMouse() {
      this.mousein = false;
    }
  },
  watch: {
    '$route.query.id'() {
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.inbutton {
  list-style: none;
  height: 37px;
  overflow: hidden;
  margin: 0;
  padding: 0;
  transition: all 0.3s;

  &.inmouse {

    height: auto;

    li {
      transition: all 0.5s;

      &:not(:first-child) {
        opacity: 1;
      }
    }
  }

  li {
    transition: all 0.5s;

    &:not(:first-child) {
      width: 120px;
      height: 30px;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, 0.60);
      opacity: 0;
      // display: none;
    }
  }


}

.details-banner {
  width: 100%;
  height: 450px;
  background: #20252f;
  position: relative;

  .details-intro {
    width: 75%;
    position: absolute;
    top: 30%;
    left: 12%;
    color: #ffffff;

    .title {
      font-size: 36px;
      font-weight: 500;
      margin-bottom: 15px;
    }

    .subtitle {
      opacity: 0.8;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      max-height: 112px;
      overflow: hidden;
      text-overflow: ellipsis; //超出文本设置为...
      display: -webkit-box; //将div1转换为盒子模型
      -webkit-line-clamp: 4; //设置div1的文本为2行
      -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
    }

    .btn {
      width: 120px;
      height: 35px;
      font-size: 14px;
      line-height: 35px;
      background: #e50009;
      text-align: center;
      cursor: pointer;
      border: 1px solid #e50009;
    }

    .btn1 {
      width: 120px;
      height: 35px;
      font-size: 14px;
      line-height: 35px;
      text-align: center;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, 0.80);
    }
  }
}

.details-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 360px;

  .contant {
    width: 75%;
    margin: 70px 0;

    .item {

      /* margin-bottom: 50px; */
      .module-detail {
        font-size: 14px;
        color: #131415;
        opacity: 0.6;
        margin: 20px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 38px;
      }
    }

    .contant-title {
      height: 45px;
      font-weight: 500;
      color: #000000;
      margin-top: 40px;
      margin-bottom: 40px;

      :first-child {
        display: inline-block;
        width: 3px;
        height: 20px;
        background: #E50009;
        margin-right: 5px;
      }

      span {
        font-size: 32px;
      }
    }

    .card {
      box-shadow: 0rem 0.04rem 0.3rem 0rem rgba(204, 204, 204, 0.7);
      margin-bottom: 40px;
    }

    .box {
      border: 1px solid #cccccc;
      height: 135px;
      padding: 18px;
      margin-bottom: 10px;
      cursor: pointer;

      .label {
        font-size: 40px;
        font-weight: 400;
        line-height: 60px;
        color: #131415;
      }

      .desc {
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
        color: #333333;
      }
    }

    .box:hover {
      box-shadow: 0px 4px 20px 0px rgba(204, 204, 204, 0.6);

      .label {
        color: #e50009;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductDetails/index.vue